import React from 'react';

interface DrawerDimmingOverlayProps {
  /** Whether the overlay is visible (controls opacity and pointer events) */
  visible: boolean;
  /** z-index for the overlay, should sit below the drawers it serves */
  zIndex: number;
  /** Optional click handler, typically used to close the active drawer */
  onClick?: () => void;
}

/**
 * Persistent dimming overlay used during drawer-to-drawer transitions.
 * Replaces individual drawer masks with a single always-rendered overlay
 * to prevent brightness flicker when swapping between drawers.
 * Uses CSS opacity transition for smooth fade in/out.
 */
const DrawerDimmingOverlay: React.FC<DrawerDimmingOverlayProps> = ({
  visible,
  zIndex,
  onClick
}) => (
  <div
    aria-hidden="true"
    onClick={onClick}
    style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0, 0, 0, 0.45)',
      zIndex,
      opacity: visible ? 1 : 0,
      pointerEvents: visible ? 'auto' : 'none',
      transition: 'opacity 0.3s'
    }}
  />
);

export default DrawerDimmingOverlay;
